/** Formátování dat v administraci (krátké české datum, relativní stáří). */
export const formatAdminDate = (date: string | null | undefined) =>
  date ? new Intl.DateTimeFormat('cs-CZ', { day: 'numeric', month: 'numeric', year: 'numeric' }).format(new Date(date)) : '-'

export const formatAdminDateTime = (date: string | null | undefined) =>
  date
    ? new Intl.DateTimeFormat('cs-CZ', { day: 'numeric', month: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(new Date(date))
    : '-'

const plural = (n: number, one: string, few: string, many: string) => (n === 1 ? one : n >= 2 && n <= 4 ? few : many)

/** "dnes", "před 3 dny", "před 2 měsíci". */
export const relativeAge = (date: string | null | undefined) => {
  if (!date) return null
  const days = Math.floor((Date.now() - new Date(date).getTime()) / 86400000)
  if (days <= 0) return 'dnes'
  if (days === 1) return 'včera'
  if (days < 31) return `před ${days} ${plural(days, 'dnem', 'dny', 'dny')}`
  const months = Math.floor(days / 30)
  if (months < 12) return `před ${months} ${plural(months, 'měsícem', 'měsíci', 'měsíci')}`
  const years = Math.floor(months / 12)
  return `před ${years} ${plural(years, 'rokem', 'lety', 'lety')}`
}

export const daysSince = (date: string | null | undefined) =>
  date ? (Date.now() - new Date(date).getTime()) / 86400000 : Infinity
